import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { MainService } from "../../main.service";
import Swal from "sweetalert2";

import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
@Component({
  selector: "app-pending-tansactions",
  templateUrl: "./pending-tansactions.component.html",
  styleUrls: ["./pending-tansactions.component.scss"],
})
export class PendingTansactionsComponent implements OnInit {
  questList: any = [];
  currentTime = "";
  user: any;
  total: number = 0;
  pagelimit: number = 10;
  totalPage: number;
  currentPage: number = 0;
  searchText;
  CouponCode: any = "";
  hasCouponCode = "";
  any;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  constructor(
    private mainservice: MainService,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    //  this.currentTime =  this.greeting()
    this.user = JSON.parse(localStorage.getItem("userData"));
    //  console.log('this.',this.questList)
    // this.getBookingList("");
    this.getPendingPayments("");
  }

  greeting() {
    const hour = moment().hour();

    if (hour > 16) {
      return "Good evening";
    }

    if (hour > 11) {
      return "Good afternoon";
    }

    return "Good morning";
  }
  pendingPayments = [];
  choirDetails = [];
  kidList = [];
  pendingBooking;
  discountData: any;
  totalAmount;
  // this.pendingDetails?._id
  getPendingPayments(text) {
    // debugger;
    this.isLoading = true;
    // let query = "couponId=" + this.pendingDetails?.couponId;
    let query = "";
    // if (this.pendingDetails?._id) {
    //   query = "bookingDetailId=" + this.pendingDetails?._id;
    // } else {
    //   query = "";
    // }

    this.mainservice.getPayments(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          // debugger;
          this.pendingPayments = res.data.pendingPaymentChoirs;
          // this.discountData = this.appliedData?.discount;
          this.totalAmount = this.pendingDetails?.totalAmount;
          console.log(
            this.pendingDetails?.totalAmount,
            "this.pendingDetails?.totalAmount"
          );

          console.log(this.discountData, " this.discountData ");
          console.log(" this.pendingPayments", this.pendingPayments);

          if (this.pendingPayments) {
            for (const data of this.pendingPayments) {
              if (data.kidsArray) {
                this.kidList = this.kidList.concat(data.kidsArray);
                this.choirDetails = this.kidList.concat(data.choirDetails);
              }

              // this.totalAmount = data?.totalAmount;
              // this.hasCouponCode = data?.couponCode;
              console.log("  this.hasCouponCode", this.hasCouponCode);
            }
          }

          // this.kidList = this.pendingPayments?.[0]?.kidsArray || [];
          console.log("this.kidList", this.kidList);
          this.SetPage();
          console.log(this.pendingPayments, "res");
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  pendingPayments1: any;
  getPendingPayments1(text) {
    // debugger;
    this.isLoading = true;
    // let query = "couponId=" + this.pendingDetails?.couponId;
    let query;

    if (this.pendingDetails?._id) {
      query = "bookingDetailId=" + this.pendingDetails?._id;
    } else {
      query = "";
    }

    this.mainservice.getPayments(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          // debugger;

          this.pendingPayments1 = res.data.pendingPaymentChoirs[0];
          this.discountData = this.pendingPayments1?.discountAmount;
          this.totalAmount = this.pendingPayments1?.totalAmount;
          this.kidList = this.pendingPayments1?.kidsArray;
          this.choirDetails = this.pendingPayments1?.choirDetails;
          if (this.pendingPayments1?.couponCode != "") {
            this.CouponCode = this.pendingPayments1?.couponCode;
            this.isAppliedCode = true;
          }
          console.log(
            this.pendingDetails?.totalAmount,
            "this.pendingDetails?.totalAmount"
          );
          console.log(this.isAppliedCode, this.discountData);
          console.log(this.discountData, " this.discountData ");
          console.log(" this.pendingPayments", this.pendingPayments);

          // if (this.pendingPayments1) {
          //   for (const data of this.pendingPayments1) {
          // if (data.kidsArray) {
          //   this.kidList = this.kidList.concat(data.kidsArray);
          //   this.choirDetails = this.kidList.concat(data.choirDetails);
          // }

          // this.totalAmount = data?.totalAmount;
          // this.hasCouponCode = data?.couponCode;
          //   console.log("  this.hasCouponCode", this.hasCouponCode);
          // }
          //   }

          // this.kidList = this.pendingPayments?.[0]?.kidsArray || [];
          console.log("this.kidList", this.kidList);
          // this.SetPage();
          console.log(this.pendingPayments, "res");
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  bookingList = [];
  getBookingList(text) {
    this.isLoading = true;
    var queryValue = this.queryParams();
    this.mainservice.getBookingList(queryValue).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.bookingList = res.data.bookings;
          this.SetPage();
          console.log(this.bookingList, "res");
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  queryParams() {
    let query =
      "limit=" +
      this.pagelimit +
      "&offset=" +
      this.pagelimit * this.currentPage;
    if (this.searchText && this.searchText != "")
      query = query + "&text=" + this.searchText;
    // if (this.searchName && this.searchName != "") query = query + "&text=" + this.searchName+"&";

    return query;
  }

  scholardetail: any;
  pendingDetails: any;
  kidsDetail: any;
  OpenModal(content, btn, data) {
    // debugger;
    this.pendingDetails = data;

    this.kidsDetail = this.pendingDetails.kidsArray;
    this.getPendingPayments1("");
    console.log("kids  this.kidsDetail ", this.kidsDetail);
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);

    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  selectedKid: any;
  OpenRemoveModal(content, btn, data) {
    this.selectedKid = data;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "sm",
    };

    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    this.questList = [];
    this.CouponCode = "";
    this.isAppliedCode = false;
    this.getPendingPayments("");
  }
  convertSecondsToTime(seconds: number): string {
    const date = new Date(seconds * 1000);

    let hours = date.getUTCHours(); // Use getUTCHours to avoid timezone offsets
    const minutes = date.getUTCMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle the case where hours = 0, should be 12 AM

    // Pad minutes with leading zero if necessary
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutesStr} ${ampm}`;
  }
  // convertSecondsToDate(seconds) {
  //   const date = new Date(seconds * 1000);
  //   const day = String(date.getDate()).padStart(2, "0");
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const year = String(date.getFullYear()).slice(-2);
  //   return `${day}/${month}/${year}`;
  // }
  convertSecondsToDate(seconds: number): string {
    const date = new Date(seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }
  choosedFile: File;
  onPicsfileChanged(event, index) {
    this.isLoading = true;
    this.choosedFile = event.target.files[0];
    if (event.target.files.length == 0) {
      this.isLoading = false;
      false;
    }

    this.mainservice.uploadImage(this.choosedFile).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.questList[index]["valuesText"] = res.data.url;
        } else {
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  SetPage() {
    this.totalPage = 0;
    this.totalPage = this.total / this.pagelimit;
    this.totalPage = Math.ceil(this.totalPage);
    if (this.totalPage == 1 || this.total <= this.pagelimit) {
      this.totalPage = 1;
    }
  }
  searchFiltersBtn() {
    // this.getBookingList("");
    this.getPendingPayments("");
  }
  nextPage() {
    this.currentPage = this.currentPage + 1;

    // this.getBookingList("");
  }
  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.getPendingPayments("");
  }
  changePageLimit() {
    this.currentPage = 0;
    this.getPendingPayments("");
  }
  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  pendingData;
  removeKid(data) {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to remove your kid?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "No, keep kid",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        // debugger;
        this.selectedKid = data;
        this.kidsDetail = this.kidsDetail.filter(
          (kid) => kid._id !== this.selectedKid._id
        );
        // this.pendingDetails = data;
        let bookingDetailId = this.pendingDetails?._id;
        let numberOfKids = this.pendingDetails?.numberOfKids;

        let req = {
          bookingDetailId: bookingDetailId,
          numberOfKids: numberOfKids,
          kidsArray: this.kidsDetail,
        };

        this.mainservice.removeKids(req).subscribe(
          (res) => {
            this.isLoading = false;

            if (res["message"] == "Success") {
              this.pendingData = res.data.response;
              this.kidsDetail = this.pendingData?.kidsArray;
              // let kidData = res.data.response.kidsArray[0];
              // this.kidsDetail = this.kidsDetail.filter(
              //   (kid) => kid._id !== kidData._id
              // );
              // this.pendingDetails.kidsArray = this.kidsDetail;

              this.pendingDetails.totalAmount = this.pendingData?.totalAmount;
              this.pendingDetails.totalTaxes = this.pendingData?.totalTaxes;
              this.pendingDetails.amount = this.pendingData?.amount;
              if (this.kidsDetail?.length) {
                this.getPendingPayments1("");
              }

              if (!this.kidsDetail || this.kidsDetail?.length === 0) {
                this.getPendingPayments("");
                this.modalRef.close();
              }
              // this.getPendingPayments("remove");
            }
          },
          (err) => {
            this.isLoading = false;
          }
        );
      }
    });
  }

  stripeData: any;
  payPayment() {
    if (this.user?.isAutoPaymentEnabled) {
      const bookingDetailId = this.pendingDetails?._id;
      this.router.navigate(["/main/payment-cards"], {
        queryParams: { bookingId: bookingDetailId },
      });
      this.modalService.dismissAll();
    } else {
      let bookingDetailId = this.pendingDetails?._id;

      if (bookingDetailId) {
        let query = `bookingDetailId=${bookingDetailId}`;

        this.mainservice.createStripe(query).subscribe({
          next: (res) => {
            this.isLoading = false;
            if (res["message"] === "Success" || res["statusCode"] === 200) {
              window.open(res.data.sessionUrl, "_self");
              console.log(res, "response of stripe checkout");
            }
          },
          error: (err) => {
            this.isLoading = false;
            console.error(err, "Stripe API error");

            if (
              err?.error?.message === "Failure" &&
              err?.error?.data?.message === "Please add a card first."
            ) {
              const bookingDetailId = this.pendingDetails?._id;
              this.router.navigate(["/main/payment-cards"], {
                queryParams: { bookingId: bookingDetailId },
              });
              this.modalService.dismissAll();
            }
          },
        });
      } else {
        console.error("Required parameters not found in content.");
      }
    }
  }

  originalTotalAmount;
  appliedData;
  isAppliedCode: boolean = false;
  appliedTotal;
  applyCode() {
    // debugger
    // this.isLoading = true;
    // let query = "choirId=" + this.id;
    if (this.CouponCode == "") {
      this._snackBar.open("Please Select Discount Code!!", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
      return;
    }

    let req = {
      couponId: this.CouponCode,
      bookingDetailId: this.pendingDetails?._id,
    };
    this.originalTotalAmount = this.pendingDetails.totalAmount;
    this.mainservice.couponApply(req).subscribe(
      (res) => {
        // debugger;
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.appliedData = res.data;
          this.pendingDetails.totalAmount = this.appliedData?.Amount;
          this.appliedTotal = this.appliedData?.discount;
          // this.discountData = this.appliedData?.discount;
          console.log(this.discountData, " this.appliedDiscount");

          this.isAppliedCode = true;
          this.getPendingPayments1("");
          console.log(this.pendingDetails, "response");
        }
      },
      (err) => {
        this.CouponCode = "";
        //     this.isLoading = false;
      }
    );
  }
  removeCode() {
    let req = {
      couponId: this.CouponCode,
      bookingDetailId: this.pendingDetails?._id,
    };
    this.mainservice.removeCoupon(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.pendingDetails.totalAmount = this.originalTotalAmount;
          this.isAppliedCode = false;
          this.CouponCode = "";

          this.getPendingPayments1("");
          console.log(this.pendingDetails, "response");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  dropdownSettings = {};
  couponList: any = [];
  selectedItems = [];
  getCouponList() {
    // this.isLoading = true;

    this.mainservice.getCouponApi().subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.couponList = res.data.couponList;
          // this.kidList = [
          //   {
          //     firstName: "testUser",
          //     lastName: "child1",
          //     age: 20,
          //     gender: "female",
          //     _id: "66be2ad0d7fdf6b0ce2eacb4",
          //   },
          //   {
          //     firstName: "child 2",
          //     lastName: "2",
          //     age: 19,
          //     gender: "female",
          //     _id: "66be2ad0d7fdf6b0ce2eacb5",
          //   },
          //   {
          //     firstName: "hbhjd",
          //     lastName: "sjgdf",
          //     age: 17,
          //     gender: "other",
          //     _id: "66c71c397f1b7868fd3bc37e",
          //   },
          // ];
          this.selectedItems = [];
          this.dropdownSettings = {
            singleSelection: false,
            idField: "_id",
            textField: "firstName",
            //  selectAllText: "Select All",
            //  unSelectAllText: "UnSelect All",
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: false,
            // disabledField: "isBookingExist", // Bind the function here
          };
          console.log(this.kidList, "res");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
}
